import { Controller } from "@hotwired/stimulus"

// The Library's search opens the filters modal, where typing matches filters and
// Enter searches lessons. It opens on the filters already applied. Hovering or
// focusing it starts loading the modal, so a click opens it straight away. What's
// typed carries over, including keys pressed while it loads.
export default class extends Controller {
  static targets = ["input"]
  static values = { url: String }

  prefetch() {
    const url = this.url
    if (this.loaded?.url === url) return

    this.loaded = { url, html: fetch(url, { headers: { "Turbo-Frame": "modal", Accept: "text/html" } }).then(response => response.text()) }
  }

  // The filters as they stand: the results page's filter bar, and the curriculum
  // answers it keeps in the address. The typed search is handed over separately.
  get url() {
    const url = new URL(this.urlValue, location.origin)
    const form = document.getElementById("library-filters")
    const params = form ? new URLSearchParams(new FormData(form)) : new URLSearchParams()
    new URLSearchParams(location.search).forEach((value, key) => {
      if ((key === "curriculum" || key.startsWith("guide[")) && !params.has(key)) params.append(key, value)
    })
    params.forEach((value, key) => { if (key !== "name" && value) url.searchParams.append(key, value) })
    return url.href
  }

  async open(event) {
    if (event.type === "keydown") event.preventDefault()
    if (this.opening) return

    this.opening = true
    this.prefetch()
    try {
      const html = await this.loaded.html
      const frame = new DOMParser().parseFromString(html, "text/html").querySelector("turbo-frame#modal")
      document.getElementById("modal").replaceChildren(...frame.childNodes)
      requestAnimationFrame(() => this.handOver())
    } catch (error) {
      this.opening = false
      throw error
    } finally {
      this.loaded = null
    }
  }

  handOver() {
    this.opening = false
    const search = document.getElementById("filter-search")
    if (!search) return

    search.value = this.inputTarget.value
    search.dispatchEvent(new Event("input", { bubbles: true }))
    search.focus()
    search.setSelectionRange(search.value.length, search.value.length)
  }
}
